import { XHRRequestCanceler } from "../../Libs/xhr/XHRRequestCanceler";
import { Constants } from "../Constants";
import { BaseApiDataResponse } from "../Models/ApiData";
import {
  AuthenticationResponse,
  LoginRequest,
  RefreshRequest,
} from "../Models/Authentication/AuthResponse";
import { BaseDataService } from "./Base/BaseDataService";

export const END_POINTS = {
  LOGIN: "/api/v1/admins/login",
  LOGOUT: "/api/v1/admins/logout",
  REFRESH: "/api/v1/admins/refresh",
};

export interface IAuthDataService {
  login: (email: string, password: string, cts: XHRRequestCanceler) => Promise<AuthenticationResponse>;
  logout: () => Promise<BaseApiDataResponse>;
  refresh: (refreshToken: string, cts?: XHRRequestCanceler) => Promise<AuthenticationResponse>;
}

class AuthDataService extends BaseDataService implements IAuthDataService {
  async login(email: string, password: string, cts: XHRRequestCanceler): Promise<AuthenticationResponse> {
    const body: LoginRequest = {
      email: email,
      password: password,
      client_id: Constants.CLIENT_ID,
      client_secret: Constants.CLIENT_SECRET,
      grant_type: "Password",
    };
    return this.post<AuthenticationResponse>(END_POINTS.LOGIN, body, cts, {
      checkError: false,
      noAuth: true,
    });
  }

  async logout(): Promise<BaseApiDataResponse> {
    return this.post<BaseApiDataResponse>(END_POINTS.LOGOUT, {});
  }

  async refresh(refreshToken: string, cts?: XHRRequestCanceler): Promise<AuthenticationResponse> {
    const body: RefreshRequest = {
      refresh_token: refreshToken,
      client_id: Constants.CLIENT_ID,
      client_secret: Constants.CLIENT_SECRET,
    };
    return this.post<AuthenticationResponse>(END_POINTS.REFRESH, body, cts, {
      checkError: false,
      noAuth: true,
    });
  }
}

const AuthDataServiceName = "AuthDataService";
export { AuthDataService, AuthDataServiceName };
